import { render, staticRenderFns } from "./ContextMenu1.vue?vue&type=template&id=63ef60a8&"
import script from "./ContextMenu1.vue?vue&type=script&lang=js&"
export * from "./ContextMenu1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports